// styled-components based extension
import styled, { css } from 'styled-components'
import { Box } from '@magicsoup.io/stock'

const MobileBox = styled(Box)`
  ${props => props.hideMobile && css`
    display: block;
    @media (max-width: 40em) {
      display: none;
    }
  `}
  ${props => props.showMobile && css`
    display: none;
    @media (max-width: 40em) {
      display: block;
    }
  `}
`

MobileBox.defaultProps = {
  as: 'div',
}

export default MobileBox